import moment from 'moment';

export function defaultSorter(a, b) {
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
};

export function dateSorter(a, b) {
    if (moment(a) < moment(b)) {
        return -1;
    } else if (moment(a) > moment(b)) {
        return 1;
    } else {
        return 0;
    }
};

export function dateRenderer(text, format = 'L LTS') {
    return moment(text).format(format);
};


// WEBPACK FOOTER //
// ./src/components/Helpers.js